import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthenticationService } from '../../services/authentication.service';
import { ErrorService } from '../../../../core/services/error.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResetPasswordRequestDto } from '../../dtos/reset-password-request.dto';

@Component({
  selector: 'app-reset-password',
  imports: [ReactiveFormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule, TranslocoPipe],
  templateUrl: './reset-password.dialog.html',
  styleUrl: './reset-password.dialog.scss'
})
export class ResetPasswordDialog implements OnInit {
  emailFormControl!: FormControl;
  errorMessage?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { email: string, customerId?: number },
    private dialogRef: MatDialogRef<ResetPasswordDialog>,
    private authenticationService: AuthenticationService, private translocoService: TranslocoService,
    private errorService: ErrorService, private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    this.emailFormControl = new FormControl<string>(this.data.email);
  }

  close(): void {
    this.dialogRef.close();
  }

  resetPassword(): void {
    let email = this.emailFormControl.value;

    let resetPasswordRequestDto: ResetPasswordRequestDto = {
      email: email,
      customerId: this.data.customerId,
    };

    this.authenticationService.resetPassword(resetPasswordRequestDto).subscribe({
      next: () => {
        this.snackBar.open(this.translocoService.translate('label.saved'), 'OK', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom'
        });
        this.dialogRef.close();
      },
      error: (error) => {
        this.errorMessage = this.errorService.handleError(error) ?? '';
      }
    });
  }
}
